import React from 'react'
import { PLACEHOLDER_MESSAGES_STEP1 } from '../../constants';
import { getApplicationValues } from './constants/applications';
import { useIntl } from 'react-intl';
import SelectWithCustomInput from './components/SelectWithCustomInput';
import { useFormikContext } from 'formik';

const ApplicationSelect = ({ name, updateField }) => {
  const intl = useIntl();
  const { values: { application } } = useFormikContext();

  return (
    <SelectWithCustomInput
      name={name}
      initialValue={application}
      updateField={updateField}
      placeholderMessage={intl.formatMessage(
        PLACEHOLDER_MESSAGES_STEP1["application"]
      )}
      selectValues={getApplicationValues(intl)}
      customOptionText={intl.locale === "es" ? "Otro" : "Other"}
    />
  );
}

export default ApplicationSelect;